<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask
      id="mask0_312_7285"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="4"
      y="4"
      width="16"
      height="16"
    >
      <path d="M4 4H20V20H4V4Z" class="fill-current" />
    </mask>
    <g mask="url(#mask0_312_7285)">
      <path
        d="M18.125 19.375H5.875C5.18463 19.375 4.625 18.8153 4.625 18.125V5.875C4.625 5.18466 5.18463 4.625 5.875 4.625H18.125C18.8154 4.625 19.375 5.18466 19.375 5.875V18.125C19.375 18.8153 18.8154 19.375 18.125 19.375Z"
        class="stroke-current"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M4.71875 16.5312L9.13175 12.1182C9.61991 11.6301 10.4113 11.6301 10.8995 12.1182L13.2812 14.5L14.413 13.3682C14.9012 12.8801 15.6926 12.8801 16.1807 13.3682L19.2344 16.4219"
        class="stroke-current"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M12.875 8.375C12.875 9.06534 13.4346 9.625 14.125 9.625C14.8154 9.625 15.375 9.06534 15.375 8.375C15.375 7.68466 14.8154 7.125 14.125 7.125C13.4346 7.125 12.875 7.68466 12.875 8.375Z"
        class="stroke-current"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
    </g>
  </svg>
</template>
